import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faStar, faQrcode, faTools,  faBriefcaseMedical, 
  faIdCard, faChartPie, faStethoscope, faHeartbeat,
  faClock, faRunning, faTint, faThermometerHalf, 
  faLungs, faWeight, faCapsules, faPills, faBed, 
  faDeaf, faLungsVirus, faHeartPulse, faSyncAlt,
  faBaby,
  faBolt,
  faEarth,
  faListDots,
  faBuilding,
  faCow
} from '@fortawesome/free-solid-svg-icons';
import './ThinkHealth.css';
import thinkhealthimage from '../../assets/pageimages/ThinkHealth.webp';

function ThinkHealthHome() {

  const LinkButton = ({ to, icon, label }) => (
    <div className="flex justify-center">
      <Link
        to={to}
        className="flex items-center flex-wrap justify-center p-3 w-full bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-all duration-300"
      >
        <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
        <span>{label}</span>
      </Link>
    </div>
  );

  const LinkNoButton = ({ to, icon, label }) => (
    <div className="flex justify-center">
      <Link
        to={to}
        className="flex items-center flex-wrap justify-center p-3 w-full bg-gray-200 text-gray-800 font-semibold rounded-lg hover:bg-gray-300 transition-all duration-300"
      >
        <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
        <span>{label}</span>
      </Link>
    </div>
  );

  return (
    <MainLayout>
      <div className="mt-12 text-sm min-h-screen bg-gradient-to-r from-pink-300 via-red-500 to-purple-600 flex flex-col items-center py-8">
        <h2 className="text-4xl font-bold text-white text-center mb-4">ThinkHealth</h2>
        <img
          src={thinkhealthimage}
          alt="ThinkHealth"
          className="w-1/3 h-auto max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl rounded-lg shadow-lg flex-wrap"
        />

        <div className="flex-grow">
          <div className="grid grid-cols md:grid-cols lg:grid-cols-5 gap-4 p-4 bg-gray-600 rounded-lg shadow-lg transition-transform transform hover:scale-105 mx-4 mt-6">
            <LinkButton to="/think-health-health-card" icon={faIdCard} label="ThinkHealthCard" />
            <LinkButton to="/think-health-health-card-vet" icon={faCow} label="ThinkHealthPetCard" />
            <LinkNoButton to="" icon={faChartPie} label="ThinkPatient Dashboard" />
            <LinkNoButton to="" icon={faStethoscope} label="Healthcare Providers" />
            <LinkNoButton to="" icon={faHeartbeat} label="Wellness Dashboard" />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default ThinkHealthHome;
